import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Cycle as CycleEntity } from '../../entities/cycle/Cycle'
import Cycle from '../cycle/Cycle'
import Modal from '../modal/Modal'
import CycleHeader from '../cycle-header/CycleHeader'
import messages from './CycleModal.messages'

export interface IOwnProps {
    cycle: CycleEntity
    open: boolean
    onClose: () => void
}

export interface IStateProps {}

export interface IDispatchProps {}

const CycleHeaderContainer = styled('div')({
    borderBottom: '2px solid rgba(212, 212, 211, 0.44)',
    boxShadow: '0px 10px 5px 0px rgba(242, 242, 242, 0.27)',
})

const CycleContainer = styled('div')({
    minHeight: 300,
    maxHeight: 'calc(100vh - 240px)',
    overflow: 'auto',
    padding: '25px 12px 8px 12px',
})

const ButtonsContainer = styled('div')({
    padding: '8px 12px 16px 12px',
})

export type IProps = IOwnProps & IStateProps & IDispatchProps

const CycleModal: React.FC<IProps> = (props) => {
    const { open, cycle, onClose } = props

    React.useEffect(() => {
        if (!cycle.orders.length) {
            onClose()
        }
    }, [cycle.orders.length, onClose])

    return (
        <Modal modalName='cycle' open={open} onClose={onClose} isWideContent>
            <CycleHeaderContainer>
                <CycleHeader cycle={cycle} active={true} />
            </CycleHeaderContainer>

            <CycleContainer>
                <Cycle cycle={cycle} isModal />
            </CycleContainer>

            <ButtonsContainer>
                <Button
                    onClick={onClose}
                    variant='contained'
                    color='primary'
                    fullWidth
                >
                    <FormattedMessage {...messages.ok} />
                </Button>
            </ButtonsContainer>
        </Modal>
    )
}

export default CycleModal
